exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".img-wrap[data-v-173ec366]{display:flex;align-items:center;justify-content:center;padding:10px}.img-wrap img[data-v-173ec366]{width:100px;height:100px;object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-173ec366&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PrivilegeRole/PrivilegeRole.vue
// module id = 454
// module chunks = 0